import React from "react";
import VideoPlayer from "../components/videoPlayer";

const VideoPlayerPage = () => {
  return (
    <>
      <VideoPlayer />
    </>
  );
};

export default VideoPlayerPage;
